const MY_USERS_AND_GROUPS_TABS_LABELS = {
  USERS: 0,
  GROUPS: 1,
};

const MY_USERS_AND_GROUPS_TABS = [
  {
    key: MY_USERS_AND_GROUPS_TABS_LABELS.USERS,
    tab_key: 'soho_my_users_and_groups_users_tab_title',
  },
  {
    key: MY_USERS_AND_GROUPS_TABS_LABELS.GROUPS,
    tab_key: 'soho_my_users_and_groups_groups_tab_title',
  },
];

const USER_ROLES = Object.freeze({
  GRANTER: 'granter',
  USER: 'user',
  EMPLOYEE: 'employee',
});

export { MY_USERS_AND_GROUPS_TABS_LABELS, MY_USERS_AND_GROUPS_TABS, USER_ROLES };
